import type { StatusTone } from '../contracts/common';
import type { ApprovalStatus, EventSource, InboxStatus, Severity, Via } from '../enums';

/** Ważność zdarzeń (Figma 02 Inbox: sekcja „Pilne”; MVP §9). */
export const SEVERITY_LABELS: Record<Severity, string> = {
  critical: 'Pilne',
  approval: 'Akceptacja',
  normal: 'Zwykłe',
  fyi: 'Do wiadomości',
};

/** Kolor tylko, gdy niesie znaczenie: pilne = czerwony, akceptacja = akcent. */
export const SEVERITY_TONES: Record<Severity, StatusTone> = {
  critical: 'danger',
  approval: 'accent',
  normal: 'neutral',
  fyi: 'neutral',
};

export const INBOX_STATUS_LABELS: Record<InboxStatus, string> = {
  unread: 'Nieprzeczytane',
  read: 'Przeczytane',
  done: 'Zrobione',
};

/** Statusy akceptacji (Figma 03 Akceptacje: „Czeka · 3”, Historia). „Wycofana” — `APPROVAL_DISPLAY_STATUS_LABELS`. */
export const APPROVAL_STATUS_LABELS: Record<ApprovalStatus, string> = {
  pending: 'Czeka',
  approved: 'Zatwierdzona',
  rejected: 'Odrzucona',
  expired: 'Wygasła',
  executing: 'Wykonywana',
  succeeded: 'Wykonana',
  failed: 'Błąd',
};

export const APPROVAL_STATUS_TONES: Record<ApprovalStatus, StatusTone> = {
  pending: 'accent',
  approved: 'accent',
  rejected: 'neutral',
  expired: 'neutral',
  executing: 'warning',
  succeeded: 'success',
  failed: 'danger',
};

/** Źródło zdarzenia (podpis w Inboxie, gdy brak nadawcy). */
export const EVENT_SOURCE_LABELS: Record<EventSource, string> = {
  ui: 'Aplikacja',
  ai: 'Copilot',
  mcp: 'MCP',
  worker: 'Automat',
  integration: 'Integracja',
  monitor: 'Monitoring',
  simulation: 'Symulacja',
};

export const VIA_LABELS: Record<Via, string> = {
  ui: 'Aplikacja',
  ai: 'AI',
  mcp: 'MCP',
  worker: 'Automat',
  system: 'System',
};
